export default __webpack_public_path__ + "static/media/logoOA.ca994a1b.svg";